// Module
var code = "<div class=\"Toggle\"></div>\n<span class=\"On\">On</span>\n<span class=\"Off\">Off</span>";
// Exports
module.exports = code;